import { SVGProps } from 'react';

export const Slash = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M17.5126 3.30469H14.0516L6.49219 20.6924H10.0442L17.5126 3.30469Z" fill="white" />
    </svg>
  );
};
